import { render, staticRenderFns } from "./TableColumnHeader.vue?vue&type=template&id=2f44c63d&lang=pug"
import script from "./TableColumnHeader.vue?vue&type=script&lang=js"
export * from "./TableColumnHeader.vue?vue&type=script&lang=js"
import style0 from "./TableColumnHeader.vue?vue&type=style&index=0&id=2f44c63d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports